import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 140 44"
    {...props}
  >
    <path
      fill="#DB4437"
      d="M7.465 12.39v13.75h8.048l7.07-12.21h16.01c-2.98-5.813-9.027-9.783-16.01-9.783A17.93 17.93 0 0 0 7.465 12.39"
    />
    <path
      fill="url(#Logo_Chrome_svg__a)"
      d="M7.465 12.39v13.75h8.048l7.07-12.21h16.01c-2.98-5.813-9.027-9.783-16.01-9.783A17.93 17.93 0 0 0 7.465 12.39"
    />
    <path
      fill="#3E2723"
      fillOpacity={0.15}
      d="m7.465 12.39 8.07 13.773.174-.109-8.114-13.881a2 2 0 0 1-.13.217"
    />
    <path
      fill="#0F9D58"
      d="m21.735 39.957 7.918-7.895v-5.921h-14.14L7.465 12.39a17.7 17.7 0 0 0-2.85 9.673c0 9.609 7.592 17.46 17.12 17.894"
    />
    <path
      fill="url(#Logo_Chrome_svg__b)"
      d="m21.735 39.957 7.918-7.895v-5.921h-14.14L7.465 12.39a17.7 17.7 0 0 0-2.85 9.673c0 9.609 7.592 17.46 17.12 17.894"
    />
    <path
      fill="#263238"
      fillOpacity={0.15}
      d="M21.517 39.957c.065 0 .152 0 .218.022L29.5 26.423l-.174-.108z"
    />
    <path
      fill="#FFCD40"
      d="m21.735 39.957 7.918-7.895V26.14z"
    />
    <path
      fill="url(#Logo_Chrome_svg__c)"
      d="m21.735 39.957 7.918-7.895V26.14z"
    />
    <path
      fill="#FFCD40"
      d="m22.583 13.93 7.07 12.21-7.918 13.817c.282.022.565.022.848.022 9.92 0 17.968-8.025 17.968-17.916 0-2.928-.718-5.704-1.958-8.133z"
    />
    <path
      fill="url(#Logo_Chrome_svg__d)"
      d="m22.583 13.93 7.07 12.21-7.918 13.817c.282.022.565.022.848.022 9.92 0 17.968-8.025 17.968-17.916 0-2.928-.718-5.704-1.958-8.133z"
    />
    <path
      fill="url(#Logo_Chrome_svg__e)"
      d="M38.593 13.93h-16.01v4.25z"
    />
    <path
      fill="url(#Logo_Chrome_svg__f)"
      d="m7.465 12.39 8.048 13.75 3.655-2.103z"
    />
    <path
      fill="url(#Logo_Chrome_svg__g)"
      d="m29.653 26.141-3.633-2.104-4.285 15.92z"
    />
    <path
      fill="#F1F1F1"
      d="M22.583 30.197c4.505 0 8.157-3.642 8.157-8.134s-3.652-8.133-8.157-8.133-8.157 3.641-8.157 8.133 3.652 8.134 8.157 8.134"
    />
    <path
      fill="#4285F4"
      d="M22.583 28.57c3.604 0 6.526-2.913 6.526-6.506s-2.922-6.507-6.526-6.507-6.526 2.913-6.526 6.507 2.922 6.506 6.526 6.506"
    />
    <path
      fill="#3E2723"
      fillOpacity={0.2}
      d="M38.484 13.713H22.583c-4.503 0-8.157 3.644-8.157 8.133v.196c0-4.49 3.654-8.134 8.157-8.134h15.989a.8.8 0 0 0-.088-.195"
    />
    <path
      fill="#fff"
      fillOpacity={0.1}
      d="M22.714 30.197h-.131a8.18 8.18 0 0 1-7.07-4.078L7.465 12.39c-.022.022-.044.066-.066.087l8.114 13.86a8.18 8.18 0 0 0 7.07 4.078 8.16 8.16 0 0 0 5.808-2.43 8.18 8.18 0 0 1-5.59 2.213c-.044.021-.066 0-.087 0"
    />
    <path
      fill="#fff"
      fillOpacity={0.1}
      d="M26.368 29.286c.109-.043.196-.108.306-.174-.11.066-.219.11-.306.174"
    />
    <path
      fill="#3E2723"
      d="M30.719 22.714v-.13q.032.033 0 .13M28.391 27.985l.522-.52.087-.152a9 9 0 0 1-.609.672"
      opacity={0.1}
    />
    <path
      fill="#3E2723"
      d="M30.523 20.111c.196.716.304 1.453.304 2.234a8 8 0 0 1-.783 3.449 8.2 8.2 0 0 0 .914-3.73c0-4.49-3.655-8.134-8.157-8.134h-.11a8.17 8.17 0 0 1 7.832 6.181"
      opacity={0.1}
    />
    <path
      fill="#3E2723"
      d="M30.675 23.192c0-.044 0-.065.022-.109-.022.044-.022.087-.022.109M25.563 29.655c.087-.044.197-.066.284-.11a1.5 1.5 0 0 0-.284.11M26.65 29.112c.045-.021.066-.043.11-.065-.022.022-.066.043-.11.065M22.692 30.197h.021a9.2 9.2 0 0 0 2.328-.369 7.6 7.6 0 0 1-2.35.369"
      opacity={0.1}
    />
    <path
      fill="#fff"
      fillOpacity={0.1}
      d="M29.653 26.14a8.3 8.3 0 0 1-2.893 2.929c-.044.021-.066.043-.11.065-.108.065-.195.108-.304.173-.043.022-.087.044-.152.087-.109.065-.24.109-.37.174a1.5 1.5 0 0 1-.283.108.3.3 0 0 1-.13.043c-.109.044-.196.066-.305.109-.021 0-.043.021-.065.021a7.6 7.6 0 0 1-2.328.37h.066a8.14 8.14 0 0 0 5.59-2.213c.218-.217.414-.456.61-.694z"
    />
    <path
      fill="#3E2723"
      d="M29.653 26.14a8.3 8.3 0 0 1-2.893 2.929c-.044.021-.066.043-.11.065-.108.065-.195.108-.304.173-.043.022-.087.044-.152.087-.109.065-.24.109-.37.174a1.5 1.5 0 0 1-.283.108.3.3 0 0 1-.13.043c-.109.044-.196.066-.305.109-.021 0-.043.021-.065.021a7.6 7.6 0 0 1-2.328.37h.066a8.14 8.14 0 0 0 5.59-2.213c.218-.217.414-.456.61-.694z"
      opacity={0.1}
    />
    <path
      fill="#fff"
      fillOpacity={0.2}
      d="M30.523 20.11c-.022-.086-.044-.151-.065-.238.152.52.239 1.041.282 1.605v.043c.022.174.022.37.022.543s0 .325-.022.499v.13c0 .13-.021.26-.043.39 0 .043 0 .065-.022.109a8 8 0 0 1-1.022 2.928l-.675 1.17-.087.153-7.156 12.493h.239l7.766-13.556c.109-.195.217-.412.326-.63.5-1.04.783-2.211.783-3.448a9.4 9.4 0 0 0-.326-2.19"
    />
    <path
      fill="#fff"
      fillOpacity={0.2}
      d="M22.583 4.343c9.898 0 17.903 7.96 17.968 17.807v-.109c0-9.868-8.049-17.894-17.968-17.894S4.615 12.173 4.615 22.063v.108c.065-9.847 8.07-17.828 17.968-17.828"
    />
    <path
      fill="#3E2723"
      fillOpacity={0.15}
      d="M22.583 39.783c9.898 0 17.903-7.96 17.968-17.807v.108C40.55 31.974 32.502 40 22.583 40S4.615 31.953 4.615 22.063v-.109c.065 9.847 8.07 17.829 17.968 17.829"
    />
    <path
      fill="url(#Logo_Chrome_svg__h)"
      d="M22.583 39.978c9.923 0 17.968-8.02 17.968-17.915S32.506 4.147 22.583 4.147 4.615 12.17 4.615 22.063s8.044 17.915 17.968 17.915"
    />
    <path
      fill="#757575"
      d="M50.34 22.519c0-3.86 2.719-6.81 6.59-6.81 3.068 0 4.787 1.821 5.57 3.622l-2.154 1.019c-.565-1.475-1.827-2.386-3.524-2.386-2.045 0-3.98 1.822-3.98 4.642 0 2.71 1.935 4.641 3.98 4.641 1.827 0 3.067-.91 3.763-2.386l2.154.911c-.805 1.822-2.61 3.623-5.678 3.623-4.002-.066-6.721-3.015-6.721-6.876m16.489-6.355-.11 1.822h.11c.674-1.128 2.284-2.147 4.089-2.147 3.307 0 4.894 2.147 4.894 5.335v7.83H73.42V21.5c0-2.603-1.37-3.514-3.176-3.514-2.045 0-3.415 1.93-3.415 3.969v7.027h-2.393V10.395h2.392zm11.485 12.818V16.164h2.284v2.039h.109c.565-1.475 2.393-2.386 3.763-2.386.805 0 1.262.108 1.827.347l-.913 2.277c-.348-.108-.805-.217-1.262-.217-1.588 0-3.306 1.367-3.306 3.753v7.027h-2.502zM99.48 22.52c0 3.86-2.72 6.81-6.592 6.81s-6.59-2.95-6.59-6.81 2.718-6.81 6.59-6.81 6.592 2.95 6.592 6.81m-2.393 0c0-2.95-2.045-4.642-4.199-4.642S88.69 19.57 88.69 22.52s2.045 4.642 4.198 4.642 4.199-1.692 4.199-4.642m4.307-6.355h2.284v1.822h.109c.674-1.258 2.393-2.147 3.981-2.147 2.044 0 3.415.91 4.089 2.494.914-1.475 2.502-2.494 4.438-2.494 3.067 0 4.546 2.147 4.546 5.335v7.83h-2.502V21.5c0-2.603-1.022-3.514-2.849-3.514-1.936 0-3.307 1.93-3.307 3.969v7.027h-2.392V21.5c0-2.603-1.023-3.514-2.85-3.514-1.936 0-3.307 1.93-3.307 3.969v7.027h-2.392V16.164zm21.166 6.355c0-3.622 2.501-6.81 6.264-6.81s6.265 2.71 6.265 6.81v.455h-10.115c.109 2.712 2.045 4.186 4.09 4.186 1.37 0 2.849-.564 3.524-2.147l2.153.911c-.805 1.822-2.61 3.514-5.569 3.514-4.002-.109-6.612-3.058-6.612-6.92m6.243-4.533c-1.828 0-3.176 1.258-3.633 3.058h7.396c-.109-1.128-1.022-3.058-3.763-3.058"
    />
    <defs>
      <radialGradient
        id="Logo_Chrome_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(17.1692 0 0 17.119 21.805 13.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#3E2723"
          stopOpacity={0.2}
        />
        <stop
          offset={1}
          stopColor="#3E2723"
          stopOpacity={0}
        />
      </radialGradient>
      <radialGradient
        id="Logo_Chrome_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(15.9371 0 0 15.8906 7.45 12.398)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#3E2723"
          stopOpacity={0.2}
        />
        <stop
          offset={1}
          stopColor="#3E2723"
          stopOpacity={0}
        />
      </radialGradient>
      <radialGradient
        id="Logo_Chrome_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(17.9436 0 0 17.8912 22.552 22.094)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#263238"
          stopOpacity={0.2}
        />
        <stop
          offset={1}
          stopColor="#263238"
          stopOpacity={0}
        />
      </radialGradient>
      <radialGradient
        id="Logo_Chrome_svg__h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(36.0934 0 0 35.988 9.983 9.037)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#fff"
          stopOpacity={0.1}
        />
        <stop
          offset={1}
          stopColor="#fff"
          stopOpacity={0}
        />
      </radialGradient>
      <linearGradient
        id="Logo_Chrome_svg__a"
        x1={10.026}
        x2={20.731}
        y1={19.593}
        y2={13.322}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#A52714"
          stopOpacity={0.6}
        />
        <stop
          offset={0.66}
          stopColor="#A52714"
          stopOpacity={0}
        />
      </linearGradient>
      <linearGradient
        id="Logo_Chrome_svg__b"
        x1={26.591}
        x2={14.697}
        y1={34.362}
        y2={27.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#055524"
          stopOpacity={0.4}
        />
        <stop
          offset={0.33}
          stopColor="#055524"
          stopOpacity={0}
        />
      </linearGradient>
      <linearGradient
        id="Logo_Chrome_svg__c"
        x1={21.366}
        x2={24.349}
        y1={14.139}
        y2={27.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#EA6100"
          stopOpacity={0.3}
        />
        <stop
          offset={0.66}
          stopColor="#EA6100"
          stopOpacity={0}
        />
      </linearGradient>
      <linearGradient
        id="Logo_Chrome_svg__d"
        x1={27.207}
        x2={30.19}
        y1={12.809}
        y2={25.911}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#EA6100"
          stopOpacity={0.3}
        />
        <stop
          offset={0.66}
          stopColor="#EA6100"
          stopOpacity={0}
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLogoChrome;
